import { useCallback } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import Iconify from 'src/components/iconify';

import { IRestaurantTableFilterValue, IRestaurantTableFilters } from 'src/types/user';

// ----------------------------------------------------------------------

type Props = {
  filters: IRestaurantTableFilters;
  onFilters: (name: string, value: IRestaurantTableFilterValue) => void;
};

export default function RestaurantTableToolbar({
  filters,
  onFilters,
}: Props) {

  const handleFilterName = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilters('title', event.target.value);
    },
    [onFilters]
  );



  return (
    <Stack
      spacing={2}
      alignItems={{ xs: 'flex-end', md: 'center' }}
      direction={{
        xs: 'column',
        md: 'row',
      }}
      sx={{
        p: 2.5,
        pr: { xs: 2.5, md: 1 },
      }}
    >


      <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }}>
        <TextField
          fullWidth
          value={filters.title}
          onChange={handleFilterName}
          placeholder="Search..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />


      </Stack>
    </Stack>
  );
}
